import Logger from "@/assets/Helper/Logger";

class Location {
    getNextShop(linkNode) {
        if (this.isGetLocationPossible()) {
            let LocationAPI = window.conf2020AppConfig['maps']['locationApi'].object;
            let callback = window.conf2020AppConfig['maps']['locationApi'].callback;

            if (typeof LocationAPI[callback] === 'function') {
                LocationAPI[callback](linkNode);
            }
        } else {
            Logger.error('Invalid callback for Location request: getNextShop');
        }
    }

    isGetLocationPossible() {
        if (typeof window.conf2020AppConfig['maps'] === 'object' &&
            typeof window.conf2020AppConfig['maps']['locationApi'] === 'object' &&
            typeof window.conf2020AppConfig['maps']['locationApi'].object === 'object' &&
            typeof window.conf2020AppConfig['maps']['locationApi'].callback === 'string' &&
            window.conf2020AppConfig['maps']['locationApi'].callback !== ''
        ) {
            return true;
        }
        return false;
    }
}

export default new Location();